import React, { useEffect, useState } from "react";
import { FaCaretUp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import LineChartComponent from "../../components/DashboardCharts/LineChartComponent";
import SemiCircleChart from "../../components/DashboardCharts/SemiCircleChart";
import EditFees from "../../components/modal/EditFees";
import appointment from "../../images/appointment.svg";
import customer from "../../images/customer.svg";
import service_provide from "../../images/service_provider.svg";
import { getApiCaller } from "../../libs/apiCaller";
import { getGreeting } from "../../libs/UnauthorisedPage";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("Consumer Error");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [consumerStatisticsActiveTab, setConsumerStatisticsActiveTab] =
    useState("This Week");
  const [
    serviceProviderStatisticsActiveTab,
    setServiceProviderStatisticsActiveTab,
  ] = useState("This Week");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleTabClick2 = (tab) => {
    setConsumerStatisticsActiveTab(tab);
  };

  const handleTabClick3 = (tab) => {
    setServiceProviderStatisticsActiveTab(tab);
  };
  const [loading, setLoading] = useState(true);
  const [dashboardInfo, setDashboardInfo] = useState({});
  const profileInfoData = useSelector((state) => state?.profile?.data);

  useEffect(() => {
    handleFetchDashboard();
  }, []);

  const handleFetchDashboard = async () => {
    try {
      setLoading(true);
      const response = await getApiCaller("admin_dashboard");
      if (response.data.status) {
        setDashboardInfo(response.data.response_data);
      }
    } catch (error) {
      toast.error("Failed to fetch dashboard data. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-[#284184] text-white rounded-b-2xl pt-3 h-56">
        <div className="px-4 md:px-10">
          <div className="">
            <p className="font-bold text-2xl md:text-3xl">
              Hello, {profileInfoData?.name} 👋🏻
            </p>
            <p className="">{getGreeting()}</p>
          </div>
        </div>
        <div className="w-full text-center">
          <p className="text-4xl font-bold md:text-5xl lg:text-6xl xl:text-8xl drop-shadow-2xl ">
            REEBUK HEALTH
          </p>
        </div>
        {loading ? (
          <div className="text-center flex items-center justify-center my-10 h-[45vh]">
            <PropagateLoader color="#284184" loading={true} size={10} />
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-10 my-5">
              <div className=" bg-white rounded-2xl p-3">
                <div className="flex gap-3 items-center">
                  <div className=" bg-slate-300 w-12 h-12 justify-items-center content-center rounded-xl">
                    <img
                      src={service_provide}
                      width={25}
                      alt="service_provide"
                    />
                  </div>
                  <p className="text-[#000]">Total Service Providers</p>
                </div>
                <div className="flex gap-3 items-center my-3 justify-between">
                  <p className="text-[#284184] font-bold text-3xl">
                    {dashboardInfo?.providers?.total_provider}
                  </p>
                  <div>
                    <div className="flex gap-1 items-center bg-[#E9F2FF] px-2 py-0.5 rounded-xl">
                      <FaCaretUp className="text-[#284184]" />
                      <p className="text-[#284184]">
                        {
                          dashboardInfo?.providers
                            ?.last_30_days_percentage_increase
                        }
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="opacity-50 text-[#000]">
                    Data obtain for last 30 days
                  </p>

                  <div className="w-full bg-gray-200 rounded-full h-2.5 my-3 dark:bg-gray">
                    <div
                      className="bg-[#284184] h-2.5 rounded-full"
                      style={{ width: "25%" }}
                    ></div>
                  </div>
                  <p className="text-[#000]">
                    {dashboardInfo?.providers?.last_30_days_percentage_increase}{" "}
                    increase in 30 days
                  </p>
                </div>
              </div>
              <div className=" bg-white rounded-2xl p-3">
                <div className="flex gap-3 items-center">
                  <div className=" bg-slate-300 w-12 h-12 justify-items-center content-center rounded-xl">
                    <img src={customer} width={25} alt="customer" />
                  </div>
                  <p className="text-[#000]">Total Consumers</p>
                </div>
                <div className="flex gap-3 items-center my-3 justify-between">
                  <p className="text-[#284184] font-bold text-3xl">
                    {dashboardInfo?.consumers?.total_consumer}
                  </p>
                  <div>
                    <div className="flex gap-1 items-center bg-[#E9F2FF] px-2 py-0.5 rounded-xl">
                      <FaCaretUp className="text-[#284184]" />
                      <p className="text-[#284184]">
                        {
                          dashboardInfo?.consumers
                            ?.last_30_days_percentage_increase
                        }
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="opacity-50 text-[#000]">
                    Data obtain for last 30 days
                  </p>

                  <div className="w-full bg-gray-200 rounded-full h-2.5 my-3 dark:bg-gray">
                    <div
                      className="bg-[#284184] h-2.5 rounded-full"
                      style={{ width: "50%" }}
                    ></div>
                  </div>
                  <p className="text-[#000]">
                    {dashboardInfo?.consumers?.last_30_days_percentage_increase}{" "}
                    increase in 30 days
                  </p>
                </div>
              </div>
              <div className=" bg-white rounded-2xl p-3">
                <div className="flex gap-3 items-center">
                  <div className=" bg-slate-300 w-12 h-12 justify-items-center content-center rounded-xl">
                    <img src={appointment} width={25} alt="appointment" />
                  </div>
                  <p className="text-[#000]">Total Appointments</p>
                </div>
                <div className="flex gap-3 items-center my-3 justify-between">
                  <p className="text-[#284184] font-bold text-3xl">
                    {dashboardInfo?.bookings?.total_bookings}
                  </p>
                  <div>
                    <div className="flex gap-1 items-center bg-[#E9F2FF] px-2 py-0.5 rounded-xl">
                      <FaCaretUp className="text-[#284184]" />
                      <p className="text-[#284184]">
                        {
                          dashboardInfo?.bookings
                            ?.last_30_days_percentage_increase
                        }
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="opacity-50 text-[#000]">
                    Data obtain for last 30 days
                  </p>

                  <div className="w-full bg-gray-200 rounded-full h-2.5 my-3 dark:bg-gray">
                    <div
                      className="bg-[#284184] h-2.5 rounded-full"
                      style={{ width: "70%" }}
                    ></div>
                  </div>
                  <p className="text-[#000]">
                    {dashboardInfo?.bookings?.last_30_days_percentage_increase}{" "}
                    increase in 30 days
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 px-4 md:px-10 my-5 gap-3">
              <div className="grid grid-cols-1 md:grid-cols-2 col-span-2 gap-3">
                <div className=" bg-white rounded-2xl p-3">
                  <p className="text-black">Scheduled appointments</p>
                  <p className="text-[#284184] font-semibold text-3xl">
                    {dashboardInfo?.scheduled_appointment}
                  </p>
                </div>
                <div className=" bg-white rounded-2xl p-3">
                  <p className="text-black">Rescheduled appointments</p>
                  <p className="text-[#284184] font-semibold text-3xl">
                    {dashboardInfo?.rescheduled_appointment}
                  </p>
                </div>
                <div className=" bg-white rounded-2xl p-3">
                  <p className="text-black">Pending Requests</p>
                  <p className="text-[#284184] font-semibold text-3xl">
                    {dashboardInfo?.pending_appointment}
                  </p>
                </div>
                <div className=" bg-white rounded-2xl p-3">
                  <p className="text-black">Cancelled appointments</p>
                  <p className="text-[#284184] font-semibold text-3xl">
                    {dashboardInfo?.cancel_appointments}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 bg-white rounded-2xl px-4 py-3">
                {dashboardInfo?.coast_data &&
                  dashboardInfo?.coast_data?.map((info, index) => {
                    return (
                      <div
                        className="flex justify-between items-center"
                        key={index}
                      >
                        <p className="text-black">{info?.title}</p>
                        <p className="text-[#284184] font-semibold text-xl">
                          {info?.is_percentage === 0 ? "$" : ""} {info?.amount}{" "}
                          {info?.is_percentage === 1 ? "%" : ""}
                        </p>
                      </div>
                    );
                  })}

                <div className="text-center">
                  <button
                    className="text-[#284184] hover:underline"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Edit Fees
                  </button>
                </div>
              </div>
              <div className="p-3 bg-white border-[#E9F2FF] rounded-2xl">
                <div className="border-2 p-1 flex rounded-lg">
                  {["Consumer Error", "ProviderError"].map((tab) => (
                    <button
                      key={tab}
                      className={`w-full px-4 py-2 text-[#80838D] rounded-lg text-left md:text-center ${
                        activeTab === tab && "bg-[#284184] text-white"
                      }`}
                      onClick={() => handleTabClick(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
                <SemiCircleChart
                  selectedTab={activeTab}
                  chartData={
                    activeTab === "Consumer Error"
                      ? dashboardInfo?.helps?.consumer_help || 0
                      : dashboardInfo?.helps?.provider_help || 0
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 px-4 md:px-10 my-5 gap-3">
              <div className=" bg-white rounded-2xl p-3">
                <div className="flex justify-between items-center">
                  <p className="text-xl font-bold	w-full text-[#284184]">
                    Consumer Statistics
                  </p>
                  <div className="flex w-full rounded-lg bg-[#F4F9FF] p-1.5">
                    {["This Week", "Monthly"].map((tab) => (
                      <button
                        key={tab}
                        className={`w-full px-4 py-2 text-[#80838D] rounded-lg text-left md:text-center ${
                          consumerStatisticsActiveTab === tab &&
                          "bg-[#284184] text-white"
                        }`}
                        onClick={() => handleTabClick2(tab)}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>
                </div>
                <LineChartComponent
                  selectedRange={consumerStatisticsActiveTab}
                  chartData={dashboardInfo?.statistic}
                  dataKey="consumers_registered" // or "providers_registered" dynamically
                />
              </div>
              <div className=" bg-white rounded-2xl p-3">
                <div className="flex justify-between items-center">
                  <p className="text-xl font-bold	w-full text-[#284184]">
                    Service Provider Statistics
                  </p>
                  <div className="flex w-full rounded-lg bg-[#F4F9FF] p-1.5">
                    {["This Week", "Monthly"].map((tab) => (
                      <button
                        key={tab}
                        className={`w-full px-4 py-2 text-[#80838D] rounded-lg text-left md:text-center ${
                          serviceProviderStatisticsActiveTab === tab &&
                          "bg-[#284184] text-white"
                        }`}
                        onClick={() => handleTabClick3(tab)}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>
                </div>
                <LineChartComponent
                  selectedRange={serviceProviderStatisticsActiveTab}
                  chartData={dashboardInfo?.statistic}
                  dataKey="providers_registered"
                />
              </div>
            </div>
          </>
        )}
      </div>
      <EditFees
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        feesData={dashboardInfo?.coast_data || []}
        handleFetchDashboard={handleFetchDashboard}
      />
    </>
  );
};

export default Dashboard;
